import React from 'react';

export default function Hero() {
  return (
    <section 
      id="home" 
      className="text-white position-relative d-flex align-items-center" 
      style={{ 
        fontFamily: "'Montserrat', sans-serif",
        minHeight: '85vh', // Thodi zyada height di hai taaki bada aur acha dikhe
        // Unsplash ki free high-quality solar energy image
        backgroundImage: "url('https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed', // Isse scroll karne par 'Parallax' 3D effect aayega
      }}
    >
      {/* Dark Blue Overlay - Isse image ke upar white text clear padhne me aayega */}
      <div 
        className="position-absolute top-0 start-0 w-100 h-100" 
        style={{ backgroundColor: 'rgba(15, 43, 91, 0.75)' }} 
      ></div>

      <div className="container position-relative z-1 text-center py-5">
        
        {/* Main Heading (Updated to new Tagline) */}
        <h2 className="display-3 fw-bolder mb-4 text-uppercase shadow-sm" style={{ letterSpacing: '1px' }}>
          Powering a <br className="d-none d-md-block" />
          <span className="text-warning">Greener Tomorrow</span>
        </h2>
        
        {/* Sub-heading / Description (Updated with Divine Solar Details) */}
        <p className="lead mx-auto mb-5 text-light fw-medium" style={{ maxWidth: '800px', fontSize: '1.25rem', lineHeight: '1.8' }}>
          Welcome to <strong>Divine Solar Energy</strong>. We specialize in premium Rooftop Solar Power Systems (TATA, Adani, Havells), Solar Inverters, Water Heaters, and complete clean energy solutions for a sustainable future.
        </p>
        
        {/* Action Buttons */}
        <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 mt-4">
          <a href="#contact" className="btn btn-warning btn-lg rounded-pill px-5 py-3 fw-bold shadow-lg transition" style={{ color: '#0f2b5b' }}>
            Get a Free Quote
          </a>
          <a href="#services" className="btn btn-outline-light btn-lg rounded-pill px-5 py-3 fw-bold shadow-lg transition">
            Explore Solutions
          </a>
        </div>

      </div>
    </section>
  );
}